<template>
  <div class="sports-up-container">
    
    <div class="sports-up-content">
      <div class="top-container">
        <!-- 标签切换 -->
        <div class="tab-switch">
          <span :class="{active: activeTab === 'punctual'}" @click="switchTab('punctual')">准点单</span>
          <span :class="{active: activeTab === 'breaking'}" @click="switchTab('breaking')">突发单</span>
        </div>

        <div class="header-actions">
          <button class="btn refresh-btn" @click="refreshData">
            <img src="@assets/img/common/reset-green.svg" alt="刷新">
            <span class="name">刷新</span>
          </button>
          <button class="btn greenBtn new-btn" @click="createNew">
            <img src="@assets/img/resources/add.svg" alt="添加">
            <span class="name">新建</span>
          </button>
        </div>
      </div>
      
      
      <!-- 时间筛选 -->
      <div  v-click-outside="closeTimeType" class="time-filter">
        <span @click="showTimeType = !showTimeType" class="filter-label">{{timeType[timeTypeIndex].name}}<i></i></span>
        <date-picker :type="'datetime'" :format="'YYYY-MM-DD HH:mm'" v-model="datePicker" range placeholder="    开始时间    ～    结束时间" calendar-icon="none" :editable="false" :clearable="true" :shortcuts="false" confirm></date-picker>
        <ul v-show="showTimeType">
          <li v-for="(item, index) in timeType" :key="item.code" @click="changeTimeType(index)">{{item.name}}</li>
        </ul>
      </div>
      
      <!-- 数据表格 -->
      <div class="data-table">
        <div class="headContainer">
          <div class="img">资讯数据图</div>
          <div class="title">标题</div>
          <div v-show="activeTab == 'punctual'" class="time">
            上屏时间
            <div class="sort">
              <p @click="sortList('1',2)" :class="{'up': true, on: sort_search.key == '1' && sort_search.sort_type == 2}"></p>
              <p @click="sortList('1',1)" :class="{'down': true, on: sort_search.key == '1' && sort_search.sort_type == 1}"></p>
            </div>
          </div>
          <div v-show="activeTab == 'punctual'" class="priority">优先级</div>
          <div class="creator">创建人</div>
          <div class="time">
            创建时间
            <div class="sort">
              <p @click="sortList('2',2)" :class="{'up': true, on: sort_search.key == '2' && sort_search.sort_type == 2}"></p>
              <p @click="sortList('2',1)" :class="{'down': true, on: sort_search.key == '2' && sort_search.sort_type == 1}"></p>
            </div>
          </div>
          <div class="status">状态</div>
          <div class="time">
            提交时间
            <div class="sort">
              <p @click="sortList('3',2)" :class="{'up': true, on: sort_search.key == '3' && sort_search.sort_type == 2}"></p>
              <p @click="sortList('3',1)" :class="{'down': true, on: sort_search.key == '3' && sort_search.sort_type == 1}"></p>
            </div>
          </div>
          <div class="action">操作</div>
        </div>
        <ul class="tableContainer">
          <li v-for="(item, index) in list" :key="index">
            <div class="img">
              <img :src="item.img_url" alt="资讯图片" class="thumb-img">
            </div>
            <div class="title">{{item.title}}</div>
            <div v-show="activeTab == 'punctual'" class="time">{{item.screen_time}}</div>
            <div v-show="activeTab == 'punctual'" class="priority">{{item.priority}}</div>
            <div class="creator">{{item.creater_name}}</div>
            <div class="time">{{item.raw_add_time}}</div>
            <div :class="{status: true, error: item.status == 4, success: item.status == 2}">
              <el-tooltip :content="item.error_text" :disabled="item.status != 4" placement="bottom">
                <span>{{item.status_text}}</span>
              </el-tooltip>
            </div>
            <div class="time">{{item.submit_time}}</div>
            <div class="action">
              <p @click="check(item)" class="green">查看</p>
              <p @click="withdraw(item.id)" v-show="item.status == 2 && activeTab == 'punctual'" class="red">撤回</p>
              <p @click="retry(item.screen_time,item.id)" v-show="item.status == 4">重试</p>
            </div>
          </li>
        </ul>
        <!-- 空状态 -->
        <div v-if="list.length == 0" class="empty-state">
          <p>暂无数据</p>
        </div>
      </div>
      
      <!-- 分页选择器 -->
      <div class="pagination-container">
        <pages :page_count="page.pageCount" :index="page.pageIndex" :total="page.total"></pages>
      </div>
    </div>
  </div>
</template>

<script>
import pages from "@components/pages";
import { apis } from "@common/config";
import common from "@common/common";
import DatePicker from 'vue2-datepicker'
import vClickOutside from "v-click-outside";

export default {
  name: "SportsUp",
  directives: {
    clickOutside: vClickOutside.directive
  },
  components: {
    pages,
    DatePicker
  },
  watch: {
    datePicker: {
      deep: true,
      handler: function(n, o) {
        this.start = common.stampToTime(n[0])
        this.end = common.stampToTime(n[1])

        this.page.pageIndex = 1
        this.getList()
      }
    }
  },
  data() {
    return {
      datePicker: '',
      start: '',
      end: '',
      activeTab: "punctual",
      dataList: [],
      page: {
        pageCount: 0,
        pageSize: 10,
        pageIndex: 1,
        total: 0
      },
      searchOptions: {},
      list: [],
      controller: null,
      consultConfig: {},
      showTimeType: false,
      timeType: [
        {
          name: '上屏时间',
          code: '1'
        },
        {
          name: '创建时间',
          code: '2'
        },
        {
          name: '提交时间',
          code: '3'
        }
      ],
      timeTypeIndex: 0,
      sort_search: {
        key: 1,
        sort_type: 1
      }
    };
  },
  mounted() {
    this.getConsultConfig()
    this.getList()
    // this.$newLibraryMaterial()
    // this.$CreateTimeOutList()
    // this.$timeOutListDetail()
  },
  methods: {
    retry(screenTime,id) {
      const now = new Date();
      const screenDate = new Date(screenTime);
      const diffMs = screenDate - now;
      const diffMins = diffMs / (1000 * 60);

      console.log(diffMins)
      
      if (diffMins <= 5) {
        this.$changeTime({id: id}).then(res => {
          if(res){
            this.getList();
          }
        })
      }else{
        common.myFetch(apis.consultRetry, {id: id, consult_type: this.activeTab == 'punctual' ? 1 : 2}).then(res => {
          if (res) {
            this.$toast('重试成功');
            this.getList();
          }
        });
      }
    },
    withdraw(id) {
      common.myFetch(apis.consultWithdraw, {id: id}).then(res => {
        if (res) {
          this.$toast('撤回成功')
          this.getList()
        }
      })
    },
    check(item) {
      item.activeTab = this.activeTab
      this.$timeOutListDetail(item)
    },
    sortList(type, order) {
      this.sort_search.key = type
      this.sort_search.sort_type = order
      this.page.pageIndex = 1
      this.getList()
    },
    changeTimeType(index) {
      this.timeTypeIndex = index
      this.showTimeType = false
      this.page.pageIndex = 1
      this.getList()
    },
    closeTimeType() {
      this.showTimeType = false
    },
    getConsultConfig() {
      let info = {
        consult_type: this.activeTab == 'punctual' ? 1 : 2
      }
      common.myFetch(apis.consultConfig, info).then(res => {
        if (res) {
          this.consultConfig = res
        }
      })
    },
    getList() {
      if (this.controller) {
        this.controller.abort(); // 终止之前的请求
      }

      this.controller = new AbortController(); // 创建新的 AbortController
      const signal = this.controller.signal; // 获取信号

      this.list = [];

      let data = {
        search_option: "",
        key_words: "",
        start_time: this.start,
        end_time: this.end,
        page: this.page.pageIndex,
        pagesize: this.page.pageSize,
        time_search_option: this.timeType[this.timeTypeIndex].code,
        sort_search: JSON.stringify(this.sort_search),
        consult_type: this.activeTab == 'punctual' ? 1 : 2
      };

       Object.assign(data, this.searchOptions);

      common.myFetch(apis.consultList, {data: data,signal: signal}).then(res => {
        if (res) {
          console.log(res)

          this.list = res.list;

          this.generateSearchs(res.params.top_search.option.list);
          this.$set(
            this.page,
            "pageCount",
            common.calculatePage(res.page.row_count - 0, this.page.pageSize)
          );
          this.$set(this.page, "total", res.page.row_count - 0);
        }
      });
    },
    generateSearchs(data) {
      // 整理搜索栏数据
      const types = data.map(i => {
        return {
          name: i.title,
          code: i.key,
          selected: i.selected
        };
      });

      const filterData = {
        types: types,
        callback: o => {
          this.getSearch(o);
        }
      };
      this.postSearch(filterData);
    },
    getSearch(d) {
      // 接收搜索框数据
      this.searchOptions = d;
      this.page.pageIndex = 1;
      this.getList();
    },
    postSearch(data) {
      // 发送搜索框数据
      this.$emit("filterData", data);
    },
    switchTab(tab) {
      if(tab === 'punctual'){
        this.timeType = [
          {
            name: '上屏时间',
            code: '1'
          },
          {
            name: '创建时间',
            code: '2'
          },
          {
            name: '提交时间',
            code: '3'
          }
        ]
        this.sortList('1',1)
      }else{
        this.timeType = [
          {
            name: '创建时间',
            code: '2'
          },
          {
            name: '提交时间',
            code: '3'
          }
        ]
        this.sortList('2',1)
      }
      this.datePicker = ''
      this.activeTab = tab;
      this.getConsultConfig();
      this.page.pageIndex = 1;
      this.getList();
    },
    refreshData() {
      this.getList();
    },
    createNew() {
      // 新建功能
      this.consultConfig.activeTab = this.activeTab
      this.consultConfig.freshFn = this.refreshData
      this.$newLibraryMaterial(this.consultConfig,this.refreshData)
    },
    viewItem(item) {
      // 查看详情
      console.log("View item:", item);
    },
    withdrawItem(item) {
      // 撤回操作
      console.log("Withdraw item:", item);
    },
    retryItem(item) {
      // 重试操作
      console.log("Retry item:", item);
    }
  }
};
</script>

<style lang="less" scoped>
.sports-up-container {
  padding: 20px;
  flex: 1;
  min-width: 0;
  
  .sports-up-content {
    background-color: #fff;
    border-radius: 4px;
    height: 100%;

    .top-container {
      display: flex;
      justify-content: space-between;
      align-content: center;
      width: 100%;
      padding: 20px 30px 0;
      box-sizing: border-box;

      .header-actions {
        display: flex;
        gap: 15px;
        
        .btn {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 120px;
          height: 40px;
          border-radius: 20px;
          border: 1px solid #41B48C;
          cursor: pointer;
          user-select: none;
          
          img {
            width: 18px;
            height: 18px;
            margin-right: 10px;
          }
          
          .name {
            font-size: 14px;
          }
          
          &:active {
            background-color: rgba(0, 0, 0, 0.2);
          }
          
          &:hover {
            position: relative;
            
            &::after {
              content: '';
              position: absolute;
              width: 100%;
              height: 100%;
              left: 0;
              top: 0;
              border-radius: inherit;
              background-color: rgba(0, 0, 0, 0.05);
            }
          }
        }
        
        .refresh-btn {
          border: 1px solid #41B48C;
          background-color: #fff;
          color: #41B48C;
          box-sizing: border-box;
        }
        
        .greenBtn {
          background-color: #41b48c;
          color: #fff;
          border: none;
        }
      }
    }
    
    .tab-switch {
      display: flex;
      margin-bottom: 26px;
      
      span {
        font-weight: bold;
        font-size: 18px;
        color: #B9C3C3;
        line-height: 25px;
        cursor: pointer;
        margin-right: 40px;
        
        &.active {
          position: relative;
          color: #41B48C;
          border-bottom-color: #41B48C;

          &::after {
            content: '';
            position: absolute;
            left: 0;
            bottom: -5px;
            width: 100%;
            height: 2px;
            background-color: #41B48C;
            border-radius: 2px;
          }
        }
      }
    }
    
    .time-filter {
      position: relative;
      display: flex;
      align-items: center;
      margin-bottom: 20px;
      padding: 0 30px;
      box-sizing: border-box;

      ul {
        position: absolute;
        top: 28px;
        left: 20px;
        display: flex;
        flex-direction: column;
        width: 88px;
        background: #FFFFFF;
        box-shadow: 4px 4px 10px 0px rgba(5,10,15,0.05);
        border-radius: 4px;

        li {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 100%;
          height: 30px;
          font-weight: 500;
          font-size: 12px;
          color: #050F0F;
          user-select: none;
          cursor: pointer;

          &.on {
            background: rgba(65,180,140,0.15);
          }

          &:hover {
            background: rgba(65,180,140,0.15);
          }
        }
      }
      
      .filter-label {
        display: flex;
        align-items: center;
        font-size: 14px;
        color: #00B789;
        margin-right: 20px;
        user-select: none;
        cursor: pointer;

        i {
          display: block;
          width: 10px;
          height: 6px;
          margin-left: 10px;
          background: url("../../assets/img/common/arrow.png") no-repeat;
          background-position: center center;
          background-size: 100% 100%;
        }
      }
      
      .date-input {
        padding: 6px 10px;
        border: 1px solid #dcdcdc;
        border-radius: 4px;
      }
      
      .filter-separator {
        color: #999;
      }
    }
    
    .data-table {
      display: flex;
      flex-direction: column;
      width: 100%;
      margin-bottom: 30px;

      .headContainer {
        display: flex;
        align-items: center;
        width: 100%;
        height: 40px;
        background: #F9F9F9;
        box-shadow: 0px 0px 10px 0px rgba(6,21,50,0.05);
        padding: 0 30px;
        box-sizing: border-box;
        font-weight: bold;
        font-size: 14px;
        color: #829191;

        .img {
          width: 98px;
        }

        .title {
          flex: 1;
          min-width: 0;
          margin-right: 10px;
        }

        .time {
          display: flex;
          align-items: center;
          width: 78px;
          margin-right: 32px;

          .sort {
            display: flex;
            flex-direction: column;
            align-items: center;
            margin-left: 6px;

            .up {
              display: block;
              width: 8px;
              height: 4px;
              background: url('../../assets/img/common/arrowIcon.png') no-repeat;
              background-position: center center;
              background-size: 100% 100%;
              transform: rotate(180deg);
              user-select: none;
              cursor: pointer;
              margin-bottom: 2px;

              &.on {
                display: block;
                width: 8px;
                height: 4px;
                background: url('../../assets/img/common/arrowIconOn.png') no-repeat;
                background-position: center center;
                background-size: 100% 100%;
                transform: rotate(0deg);
                user-select: none;
                cursor: pointer;
                margin-bottom: 2px;
              }
            }

            .down {
              display: block;
              width: 8px;
              height: 4px;
              background: url('../../assets/img/common/arrowIcon.png') no-repeat;
              background-position: center center;
              background-size: 100% 100%;
              user-select: none;
              cursor: pointer;

              &.on {
                display: block;
                width: 8px;
                height: 4px;
                background: url('../../assets/img/common/arrowIconOn.png') no-repeat;
                background-position: center center;
                background-size: 100% 100%;
                transform: rotate(180deg);
                user-select: none;
                cursor: pointer;
                margin-bottom: 2px;
              }
            }
          }
        }

        .priority {
          width: 42px;
          margin-right: 40px;
          text-align: center;
        }

        .creator {
          width: 42px;
          margin-right: 40px;
          text-align: center;
        }

        .status {
          width: 56px;
          margin-right: 40px;
          text-align: center;
        }

        .action {
          width: 90px;
        }
      }

      .tableContainer {
        display: flex;
        flex-direction: column;
        width: 100%;

        li {
          display: flex;
          align-items: center;
          width: 100%;
          min-height: 88px;
          font-weight: 400;
          font-size: 14px;
          color: #050F0F;
          padding: 10px 30px;
          box-sizing: border-box;

          &:hover {
            background: rgba(185,195,195,0.15);
          }

          .img {
            width: 98px;

            img {
              width: 68px;
              height: 68px;
              border-radius: 4px;
              object-fit: contain;
            }
          }

          .title {
            flex: 1;
            min-width: 0;
            overflow: hidden;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            margin-right: 10px;
            font-size: 16px;
            line-height: 22px;
          }

          .time {
            display: flex;
            align-items: center;
            width: 78px;
            margin-right: 32px;
            font-size: 14px;
            color: #B9C3C3;
          }

          .priority {
            width: 42px;
            margin-right: 40px;
            text-align: center;
          }

          .creator {
            width: 42px;
            margin-right: 40px;
            text-align: center;
          }

          .status {
            width: 56px;
            margin-right: 40px;
            text-align: center;
            color: #B9C3C3;

            &.error {
              color: #FF555A;
            }

            &.success {
              color: #41B48C;
            }
          }

          .action {
            display: flex;
            align-items: center;
            min-width: 90px;

            p {
              display: flex;
              justify-content: center;
              align-items: center;
              width: 40px;
              height: 30px;
              background: #FFFFFF;
              box-shadow: 2px 2px 8px 0px rgba(0,0,0,0.1);
              border-radius: 4px;
              font-weight: bold;
              font-size: 14px;
              color: #829191;
              user-select: none;
              cursor: pointer;
              margin-left: 10px;

              &:active {
                background-color: rgba(0, 0, 0, 0.2);
              }
              
              &:hover {
                position: relative;
                
                &::after {
                  content: '';
                  position: absolute;
                  width: 100%;
                  height: 100%;
                  left: 0;
                  top: 0;
                  border-radius: inherit;
                  background-color: rgba(0, 0, 0, 0.05);
                }
              }

              &:nth-last-of-type(1) {
                margin-right: 0;
              }

              &.green {
                background: #41B48C;
                color: #FFFFFF;
                margin-left: 0px;
              }

              &.red {
                color: #FF555A;
                margin-left: 10px;
              }
            }
          }
        }
      }
      
      .empty-state {
        padding: 60px 0;
        text-align: center;
        color: #999;
      }
    }
    
    .pagination-container {
      margin-top: 20px;
      margin-bottom: 20px;
    }
  }
}
</style>